import { Login } from 'react-admin';

const CustomLoginPage = () => <Login backgroundImage="/admin-login.svg" />;

export default CustomLoginPage;
